export default "__VITE_ASSET__27380add__"